import * as React from "react";
import type { PageHeaderProps } from "../../components/PageHeader/PageHeader.web.data";
import type { SiteSetting } from "../../types";
import { Layout } from "../Layout.web";
import {
  DetailPageContent,
  type DetailPageContentProps,
} from "./DetailPageContent.web";

export type DetailContainerProps = {
  header: PageHeaderProps;
  setting: SiteSetting;
} & DetailPageContentProps;

export const DetailContainer: React.FC<DetailContainerProps> = (props) => {
  return (
    <Layout header={props.header} setting={props.setting}>
      <DetailPageContent {...props} />
    </Layout>
  );
};
